module.exports = __webpack_public_path__ + "img/topTyre.8756e836.png";